// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectComparativeLandUseQueryResult, selectComparativeLandUsesPageLoading, selectComparativeLandUsesShowInitWaitingMessage} from '../_selectors/comparative-land-use.selectors';

export class ComparativeLandUsesDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectComparativeLandUsesPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectComparativeLandUsesShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectComparativeLandUseQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
